__turbopack_context__.v({
  "client": "clients-module-scss-module__Wv5TyG__client",
  "clients": "clients-module-scss-module__Wv5TyG__clients",
  "h1": "clients-module-scss-module__Wv5TyG__h1",
  "image": "clients-module-scss-module__Wv5TyG__image",
  "link": "clients-module-scss-module__Wv5TyG__link",
  "wrapper": "clients-module-scss-module__Wv5TyG__wrapper",
});
